/**
 * Wrapper de rutas que exigen sesión.
 *
 * - Mientras se resuelve la sesión inicial (leer localStorage), muestra un
 *   loading spinner mínimo.
 * - Si no hay session, redirige a `/login` preservando la URL original
 *   en `state.from` para que el Login pueda volver al destino original
 *   después de autenticar.
 * - Si hay session, renderiza los children.
 */
import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";

import { useAuth } from "@/lib/auth";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { session, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-surface">
        <div className="text-sm text-slate-500">Cargando…</div>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
}
